import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {PicCenterOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import SubjectSelect from "../../piece/SubjectSelect";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <PicCenterOutlined/> Subject
            </FilterButton>
            <Modal
                title='Subject Filter'
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            subjectFilter: {
                                text: 'Subject:',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <SubjectSelect
                    placeholder='Please select subject'
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}